import { RepositoryFactory, Repositories } from '@/repositories/repositoryFactory'
import StaticFileRepository from '@/repositories/staticFileRepository'
import TranslationModel from '../models/translationModel'
import VueI18n from 'vue-i18n'

export default class TranslationService {

  currentTranslations: TranslationModel = new TranslationModel()

  allTranslationsLoaded = false

  loadAdditionalApiTranslations (i18n: VueI18n): Promise<void> {
    // If already loaded all translations we don't need to do this again (added because of beforeRoute guard)
    if (this.allTranslationsLoaded) {
      return Promise.resolve()
    }
    let baseLang: Array<any> = []

    const langs = this.currentTranslations.langs

    // First call the base language, then call the rest
    return RepositoryFactory.get(Repositories.Vehicle).getTypes(langs[0]).then((result: any) => {
      const promiseArray = []
      baseLang = result

      this.setTranslationFromArray(baseLang, result, 'name', langs[0])

      for (let index2 = 0; index2 < result.length; index2++) {
        this.setTranslationFromArray(baseLang[index2].searchAreas, result[index2].searchAreas, 'label', langs[0])
      }

      i18n.setLocaleMessage(langs[0], this.currentTranslations.translations[langs[0]])

      for (let index = 1; index < langs.length; index++) {
        const lang = langs[index]
        promiseArray.push(RepositoryFactory.get(Repositories.Vehicle).getTypes(lang).then((result: any) => {

          this.setTranslationFromArray(baseLang, result, 'name', lang)

          for (let index2 = 0; index2 < result.length; index2++) {
            this.setTranslationFromArray(baseLang[index2].searchAreas, result[index2].searchAreas, 'label', lang)
          }

          i18n.setLocaleMessage(lang, this.currentTranslations.translations[lang])
        }))
      }
      return Promise.all(promiseArray).then(() => {
        this.allTranslationsLoaded = true
      })
    })
  }

  getInitialJsonTranslations (): Promise<TranslationModel> {
    const langs = this.currentTranslations.langs

    const promiseArray = []
    for (let index = 0; index < langs.length; index++) {
      const lang = langs[index]
      promiseArray.push(new StaticFileRepository().getFile('cfg/' + lang + '.json').then((result: any) => {
        this.currentTranslations.translations[lang] = { ...this.currentTranslations.translations[lang], ...result }
      }))

    }

    return Promise.all(promiseArray).then(() => {
      return this.currentTranslations
    })
  }

  private setTranslationFromArray (baseLang: Array<any>, translations: Array<any>, label: any, lang: string): void {

    for (let index = 0; index < translations.length; index++) {
      const element = translations[index]
      this.currentTranslations.translations[lang][baseLang[index][label]] = element[label]
    }

  }

}
